const defaultProps = require('./default-props');

const slots = [
  {
    slotId: 'menu-bar',
    label: 'Menu bar'
  },
  {
    slotId: 'footer',
    label: 'Footer area'
  }
];

const templateSettings = [
  {
    type: 'STRING',
    key: 'error_text',
    label: 'Error Text',
  },
  {
    type: 'STRING',
    key: 'error_code',
    label: 'Error Code',
  },
  {
    type: 'STRING',
    key: 'cta_text',
    label: 'CTA Text'
  },
  {
    type: 'STRING',
    key: 'cta_url',
    label: 'CTA Url'
  }
];

export default {
  id: 'ErrorPage',
  name: 'Error Page',
  creator: 'FF Web',
  updatedBy: 'Claire Lin',
  createdAt: 1508459822000,
  updatedAt: 1508459822000,
  slots,
  templateSettings,
  defaultProps
};
